import { Flex, Space, Text } from '@mantine/core';
import { useWindowSize } from '../../../../hooks';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { BaseLayout } from '../../navigation';
import { ClosedQuestionnaires, OpenQuestionnaires } from './components';
import withStoreProvider from '../../../../util/withStoreProvider';
import {
  useVoucherStateStore,
  VoucherStateStore,
  VoucherStateStoreProvider,
} from './stores/VoucherStateStore';
import { useEffect } from 'react';

const Questionnaires = observer(() => {
  const isSmallScreen = useWindowSize(500);
  const { t } = useTranslation('questionnaire');
  const store = useVoucherStateStore();

  useEffect(() => {
    store.loadVoucherStates();

    return () => {
      store.resetStore();
    };
  }, [store]);

  return (
    <BaseLayout>
      <Flex
        direction="column"
        maw={1100}
        gap={20}
        bg="#fff"
        align="flex-start"
        p={isSmallScreen ? 20 : 40}
      >
        <Text fw="600" size="28px" lh="38px">
          {t('Title')}
        </Text>

        <Space />

        <Flex
          direction={isSmallScreen ? 'column' : 'row'}
          wrap="wrap"
          w="100%"
          gap={60}
        >
          <OpenQuestionnaires />
          <ClosedQuestionnaires />
        </Flex>
      </Flex>
    </BaseLayout>
  );
});

export const QuestionnairesScreen = withStoreProvider(
  new VoucherStateStore(),
  VoucherStateStoreProvider,
)(Questionnaires);
